/* src/app/components/ComingSoonPage/index.js */

import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import styles from './styles';

const ComingSoonPage = ({ classes }) => (
  <div className={classes.fillPage}>
    <Typography className={classes.text}>
      {'Coming Soon'}
    </Typography>
  </div>
);

ComingSoonPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ComingSoonPage);



// WEBPACK FOOTER //
// ./src/app/components/ComingSoonPage/index.js